module.exports = __webpack_public_path__ + "img/idimg.2a5a8d8e.png";